import AiHttp from '@/plugin/aiAxiox';

export default {
  /**
   * ai 聊天
   */
  // chatHello: (data: any): Promise<any> => {
  //   return AiHttp.post('api/chat/questionnaireInit', data);
  // },
  /**
   * ai 聊天
   */
  // chatExamInit: (data: any): Promise<any> => {
  //   return AiHttp.post('chat/ExamInit', data);
  // },
  /**
   * ai 聊天（考试测试用）
   */
  // chatExamInit: (data: any): Promise<any> => {
  //   return AiHttp.post('api/exam/ExamInit', data);
  // },
  /**
   * ai 聊天（测试用）
   */
  // chatgetQuestionType: (data: any): Promise<any> => {
  //   return AiHttp.post('api/chat/getQuestionType', data);
  // },
  /**
   * ai 聊天
   */
  // chatgenerate: (data: any): Promise<any> => {
  //   return AiHttp.post('chat/generate', data);
  // },
  /**
   * ai 聊天
   */
  // worldFileAnalyze: (data: any): Promise<any> => {
  //   return AiHttp.post('/analyze/worldFileAnalyze', data);
  // },
  aiGenerateSSE: (data: any): Promise<any> => {
    return AiHttp.post('question/ai_question_type', data);
  },
  aiExamTypeSSE: (data: any): Promise<any> => {
    return AiHttp.post('question/ai_exam_type', data);
  },
};
